import { useUserAccess } from '@/hooks/useUserAccess';
import { ParticipantDashboard } from '@/pages/participant/ParticipantDashboard';
import PublicHomePage from '@/pages/PublicHomePage';
import WelcomeOnboardingModal from '@/components/onboarding/WelcomeOnboardingModal';

export default function DashboardRouter() {
  const { hasActiveCohort, isLoading } = useUserAccess();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary" />
      </div>
    );
  }

  if (hasActiveCohort) {
    return <ParticipantDashboard />;
  }

  return (
    <>
      <PublicHomePage />
      <WelcomeOnboardingModal />
    </>
  );
}
